export default function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/@babel/runtime/helpers/esm/inheritsLoose.js
// module id = 138
// module chunks = 2 3 4 5 6 8 9 10 11 12 13